export default {

	init() {
		document.querySelectorAll('a').forEach((elm) => {
			const a = new RegExp(`/${window.location.host}/`);
			if (!a.test(elm.href)) {
				elm.addEventListener('click', (event) => {
					event.preventDefault();
					event.stopPropagation();
					window.open(elm.href, '_blank');
				});
			}
		});
	},

};



// WEBPACK FOOTER //
// ./src/js/components/external-links.js